const firebaseMessages: Record<string, string> = {
    "auth/invalid-login-credentials": "You've provided incorrect credentials.",
    "auth/claims-too-large": "The claims payload provided exceeds the maximum allowed size.",
    "auth/email-already-in-use": "The email address is already in use by another account.",
    "auth/id-token-expired": "The user's ID token has expired.",
    "auth/id-token-revoked": "The user's ID token has been revoked.",
    "auth/insufficient-permission": "The operation attempted requires additional permissions.",
    "auth/internal-error": "An internal error has occurred.",
    "auth/invalid-argument": "An invalid argument was provided.",
    "auth/invalid-claims": "The provided custom claims are invalid.",
    "auth/invalid-continue-uri": "The continue URI provided in the request is invalid.",
    "auth/invalid-creation-time": "The creation time provided in the request is invalid.",
    "auth/invalid-credential": "The credential provided is invalid.",
    "auth/invalid-disabled-field": "The disabled field provided is invalid.",
    "auth/invalid-display-name": "The display name provided is invalid.",
    "auth/invalid-dynamic-link-domain": "The provided dynamic link domain is not authorized.",
    "auth/invalid-email": "The email address provided is not valid.",
    "auth/invalid-email-verified": "The email address provided is not verified.",
    "auth/invalid-hash-algorithm": "The provided hash algorithm is invalid.",
    "auth/invalid-hash-block-size": "The provided hash block size is invalid.",
    "auth/invalid-hash-derived-key-length": "The provided hash derived key length is invalid.",
    "auth/invalid-hash-key": "The provided hash key is invalid.",
    "auth/invalid-hash-memory-cost": "The provided hash memory cost is invalid.",
    "auth/invalid-hash-parallelization": "The provided hash parallelization is invalid.",
    "auth/invalid-hash-rounds": "The provided hash rounds is invalid.",
    "auth/invalid-hash-salt-separator": "The provided hash salt separator is invalid.",
    "auth/invalid-id-token": "The provided ID token is invalid.",
    "auth/invalid-last-sign-in-time": "The provided last sign-in time is invalid.",
    "auth/invalid-page-token": "The provided page token is invalid.",
    "auth/invalid-password": "The provided password is invalid.",
    "auth/invalid-password-hash": "The provided password hash is invalid.",
    "auth/invalid-password-salt": "The provided password salt is invalid.",
    "auth/invalid-phone-number": "The provided phone number is not valid.",
    "auth/invalid-photo-url": "The provided photo URL is not valid.",
    "auth/invalid-provider-data": "The provided provider data is invalid.",
    "auth/invalid-provider-id": "The provided provider ID is invalid.",
    "auth/invalid-session-cookie-duration": "The provided session cookie duration is invalid.",
    "auth/invalid-uid": "The provided user UID is invalid.",
    "auth/invalid-user-import": "The user import file is invalid.",
    "auth/invalid-action-code": "Action code is invalid.",
    "auth/maximum-user-count-exceeded":
        "The maximum allowed number of users to import has been exceeded.",
    "auth/missing-android-pkg-name": "The Android package name is missing.",
    "auth/missing-continue-uri": "The continue URI is missing.",
    "auth/missing-hash-algorithm": "The hash algorithm is missing.",
    "auth/missing-ios-bundle-id": "The iOS bundle ID is missing.",
    "auth/missing-uid": "The user UID is missing.",
    "auth/phone-number-already-exists": "The phone number is already in use by another account.",
    "auth/project-not-found":
        "The Firebase project corresponding to the provided credential was not found.",
    "auth/reserved-claims": "The provided custom claims contain reserved keys.",
    "auth/session-cookie-expired": "The session cookie has expired.",
    "auth/session-cookie-revoked": "The session cookie has been revoked.",
    "auth/uid-already-exists": "The provided UID is already in use by another user.",
    "auth/unauthorized-continue-uri": "The domain of the continue URI is not whitelisted.",
    "auth/user-not-found": "There is no user corresponding to the provided identifier.",
    "auth/app-deleted": "The Firebase project associated with the app has been deleted.",
    "auth/app-not-authorized": "The app is not authorized to use Firebase Authentication.",
    "auth/argument-error": "An argument provided to the authentication method was invalid.",
    "auth/invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
    "auth/invalid-user-token": "The user's token is invalid, perhaps because it has expired.",
    "auth/invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
    "auth/network-request-failed":
        "A network error (such as timeout, interrupted connection) has occurred.",
    "auth/operation-not-allowed":
        "The given sign-in provider is disabled for this Firebase project.",
    "auth/requires-recent-login":
        "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    "auth/too-many-requests":
        "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
    "auth/unauthorized-domain": "The domain of the provided ID token is not authorized.",
    "auth/user-disabled": "The user account has been disabled by an administrator.",
    "auth/user-token-expired": "The user's token has expired.",
    "auth/web-storage-unsupported":
        "This browser is not supported or 3rd party cookies and data may be disabled.",
    "storage/unknown": "An unknown error occurred.",
    "storage/object-not-found": "The requested object does not exist.",
    "storage/bucket-not-found": "The specified bucket does not exist.",
    "storage/project-not-found": "The specified project does not exist.",
    "storage/quota-exceeded": "The operation would exceed the storage quota.",
    "storage/unauthenticated": "The user is not authenticated, please sign in.",
    "storage/unauthorized": "The user does not have permission to access the object.",
    "storage/retry-limit-exceeded": "The maximum number of retries has been exceeded.",
    "storage/invalid-checksum": "The uploaded object's checksum does not match.",
    "storage/canceled": "The upload or download was canceled.",
    "storage/invalid-event-name": "The event name provided is invalid.",
    "storage/invalid-url": "The provided URL is not valid.",
    "storage/invalid-argument": "An invalid argument was provided.",
    "storage/no-default-bucket": "No default bucket has been set in the Storage service.",
    "storage/cannot-slice-blob": "The blob cannot be sliced due to browser limitations.",
    "storage/server-file-wrong-size": "The server reported an incorrect file size.",
};

export { firebaseMessages };
